import { Profile } from "../types/profile";

/**
 * Get full name string from profile
 */
export const getFullName = (userProfile?: Profile): string => {
  if (userProfile?.firstName && userProfile?.lastName) {
    return `${userProfile.firstName} ${userProfile.lastName}`;
  }
  if (userProfile?.name) {
    return userProfile.name;
  }
  if (userProfile?.firstName) {
    return userProfile.firstName;
  }
  if (userProfile?.lastName) {
    return userProfile.lastName;
  }
  return userProfile?.email || "";
};

/**
 * Get user initials from profile: first letter of first and last name
 */
export const getUserInitials = (userProfile?: Profile): string => {
  const firstName = userProfile?.firstName?.trim();
  const lastName = userProfile?.lastName?.trim();
  if (firstName || lastName) {
    return `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
  }

  // Fallback to name: first letter of its first and last word
  const nameParts = userProfile?.name?.trim().split(/\s+/).filter(Boolean);
  if (nameParts?.length) {
    const last = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
    return `${nameParts[0][0]}${last[0] ?? ""}`.toUpperCase();
  }

  // Fallback to email if no name available
  if (userProfile?.email && userProfile.email.trim().length > 0) {
    return userProfile.email.trim()[0].toUpperCase();
  }

  return "";
};

/**
 * Generate color from string using Pimo brand blue
 * Matches product-frontend styling - always returns light blue
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const stringToColor = (_string: string): string => {
  // Always return Pimo light blue to match product-frontend
  return "#39A1F2";
};
